/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Home from './Home';
import { homeFetch } from '../../actions/home';
import { trackEventLog } from '../../core/utils'

async function action({ store }) {
  trackEventLog('/w/')
  await store.dispatch(homeFetch())
  // if (!store.getState().home.fixedEntries.length) await store.dispatch(homeFetch());
  if (global && global.NProgress) {
    global.NProgress.done()
  }
  return {
    chunks: ['home'],
    title: '有道精品课',
    component: <Home />,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/home/index.js